if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        if (!this.form) return;
        if (this.variantIdInput) this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton ? this.submitButton.querySelector('span') : null;
        this.loadingSpinner = this.querySelector('.loading__spinner');

        if (document.querySelector('cart-drawer') && this.submitButton) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (!this.submitButton) return;
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        if (this.loadingSpinner) this.loadingSpinner.classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        try {
          this.syncFitmentState(formData);
        } catch (error) {
          console.warn('Fitment status was not synced:', error);
        }
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              if (this.submitButtonText) this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            if (this.loadingSpinner) this.loadingSpinner.classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
          }
      }

      syncFitmentState(formData) {
        const fitmentState = this.getFitmentState();
        const productId = this.dataset.productId;

        ['properties[_fitment_status]', 'properties[_fitment_vehicle]', 'properties[_fitment_product_id]'].forEach((name) => {
          formData.delete(name);
        });

        if (!productId) return;

        try {
          window.localStorage.setItem(
            `soillar-fitment-state-${productId}`,
            JSON.stringify({
              version: 2,
              status: fitmentState.status,
              vehicle: fitmentState.vehicle,
              updatedAt: Date.now(),
            })
          );
        } catch (error) {
          // Storage can be unavailable in private browsing.
        }
      }

      getFitmentState() {
        const root = this.closest('[id^="MainProduct-"]') || this.closest('.product');
        const vehicle = this.getSelectedVehicleLabel();
        const result = root && root.querySelector('#valid');
        const loading = root && root.querySelector('#vfitz_search_btn .loading:not(.hide):not(.hidden)');
        if (!result || loading) return { status: 'pending', vehicle };

        // VFitz renders its labels with CSS; only the result classes carry state.
        const verified = result.classList.contains('valid');
        const notFit = result.classList.contains('invalid');
        if (verified === notFit) return { status: 'pending', vehicle };

        return { status: verified ? 'verified' : 'not_fit', vehicle };
      }

      getSelectedVehicleLabel() {
        const garageVehicle = this.getVFitzGarageVehicleLabel();
        if (garageVehicle) return garageVehicle;

        const candidates = [
          '.vfitz-vehicle-label',
          '.select-tips',
          '[data-vfitz-selected-vehicle]',
          '[class*="vehicle-label"]',
        ];

        for (const selector of candidates) {
          const element = document.querySelector(selector);
          const text = element && element.textContent ? element.textContent.replace(/\s+/g, ' ').trim() : '';
          if (text && !/^(select|verify|choose|find parts|year|make|model)/i.test(text)) return text;
        }

        return '';
      }

      getVFitzGarageVehicleLabel() {
        const params = this.getVFitzSearchParams();
        if (!params) return '';

        return ['year', 'make', 'model', 'sub_model', 'submodel', 'engine']
          .map((key) => params[key])
          .filter(Boolean)
          .join(' ')
          .replace(/-/g, ' ')
          .trim();
      }

      getVFitzSearchParams() {
        if (window.searchParams && typeof window.searchParams === 'object') return window.searchParams;

        try {
          if (window.vfitzKey && window.vfitzKey.fn && window.vfitzKey.fn.getGarageData) {
            const garageData = window.vfitzKey.fn.getGarageData();
            const firstVehicle = Array.isArray(garageData) ? garageData[0] : null;
            if (firstVehicle && firstVehicle.param) return firstVehicle.param;
          }
        } catch (error) {
          return null;
        }

        return null;
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text && this.submitButtonText) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          if (this.submitButtonText) this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
